import type { FlowFieldDefinition } from '../types';

export const REQUEST_FLOW_FIELD_IDS = {
  currentRequestItem: 'currentRequestItem',
  requestItems: 'requestItems',
} as const;

export const REQUEST_FLOW_FIELDS: FlowFieldDefinition[] = [
  {
    id: REQUEST_FLOW_FIELD_IDS.currentRequestItem,
    label: 'Current Request Item',
    type: 'context.item',
  },
  {
    id: REQUEST_FLOW_FIELD_IDS.requestItems,
    label: 'Request Items',
    type: 'list.request-item',
    multiple: true,
  },
];
